import { Fragment } from 'react';
import { FormControl, Select, MenuItem, Grid } from '@mui/material';
import { createTheme, ThemeProvider} from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import FieldNames from '../../defaults/FieldNames.json';
import BasicTextField from '../details/customPanels/BasicTextField';

const BlueAlien = "#1976d2";

const useStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "2px solid red"
    },
    "&&:after": {
      borderBottom: "2px solid red"
    }
  },
  condensedFormControl: {
    margin: "5px 15px 5px 15px",
    minWidth: 120,
    width: '90%'
  },
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '90%'
  },
  snackBarStyle: {
    top: '120px !important'
  },
});

const theme = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: 'green'
      }
    },
    MuiOutlinedInput: {
      root: {
        '& $notchedOutline': {
          //initial border
          borderColor: BlueAlien,
        },
        '&:hover $notchedOutline': {
          //border on hover
          borderColor: BlueAlien,
          border: '2px solid'
        },
        '&$focused $notchedOutline': {
          //border on focus
          borderColor: BlueAlien,
          border: '2px solid'
        },
      },
    }
  },
});

export default function AdminUserAssignment({ isCreate, allUsers, setUserID, setIsUserDirty, userID, setFirstName, firstName,
  setLastName, lastName, setEmail, email, setNifcUsername, nifcUsername, userIsAdmin, setUserIsAdmin, 
  userIsActive, setUserIsActive, userIsFuels, setUserIsFuels, userIsPostFire, setUserIsPostFire, 
  isTribalUser, setIsTribalUser, setRole, setSelectedRole, setAgencySelection, isNifcAlreadyUsed, setIsNifcAlreadyUsed }) {

  const classes = useStyles();
  return (
      <Fragment>
          {userID && setUserID && (
              <FormControl variant='standard' className={classes.condensedFormControl}>
                  <ThemeProvider theme={theme}>
                      <Grid
                          item
                          size={12}
                          container
                          direction='row'
                          className='grid-item'
                          style={{ alignItems: 'center', paddingRight: '5px' }}
                      >
                          <Grid item size={6}>
                              <span>
                                  <label>User ID</label>
                              </span>
                          </Grid>
                          <Grid item size={6}>
                              <BasicTextField
                                  field='userID'
                                  label='User ID'
                                  value={userID}
                                  setValue={setUserID}
                                  onFieldChange={() => setIsUserDirty(true)}
                                  variant={'standard'}
                                  placeholder={'User ID'}
                                  useFullWidth={true}
                                  styleOverride={{}}
                                  isDisabled={true}
                              />
                          </Grid>
                      </Grid>
                  </ThemeProvider>
              </FormControl>
          )}
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>First Name</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <BasicTextField
                              field='firstName'
                              label='First Name'
                              value={firstName}
                              setValue={setFirstName}
                              onFieldChange={() => setIsUserDirty(true)}
                              variant={'standard'}
                              placeholder={'Enter first name'}
                              useFullWidth={true}
                              styleOverride={{}}
                          />
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>Last Name</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <BasicTextField
                              field='lastName'
                              label='Last Name'
                              value={lastName}
                              setValue={setLastName}
                              onFieldChange={() => setIsUserDirty(true)}
                              variant={'standard'}
                              placeholder={'Enter last name'}
                              useFullWidth={true}
                              styleOverride={{}}
                          />
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>Email</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <BasicTextField
                              field='email'
                              label='Email'
                              value={email}
                              setValue={setEmail}
                              onFieldChange={() => setIsUserDirty(true)}
                              variant={'standard'}
                              placeholder={'Enter email'}
                              useFullWidth={true}
                              styleOverride={{}}
                          />
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>Nifc Username</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <BasicTextField
                              field='username'
                              label='Username'
                              value={nifcUsername}
                              setValue={setNifcUsername}
                              onFieldChange={(field, value) => {
                                  if (
                                      isCreate &&
                                      allUsers &&
                                      allUsers.length &&
                                      setIsNifcAlreadyUsed
                                  ) {
                                      const allNifcUsernames = allUsers.map(
                                          (x) =>
                                              x[FieldNames.userFields.nifcUsername] ??
                                              x[FieldNames.userFields.nifcUsername].toLowerCase()
                                      );
                                      if (
                                          value &&
                                          allNifcUsernames &&
                                          allNifcUsernames.includes(value.toLowerCase())
                                      ) {
                                          setIsNifcAlreadyUsed(true);
                                      } else {
                                          setIsNifcAlreadyUsed(false);
                                      }
                                  }
                                  setIsUserDirty(true);
                              }}
                              variant={'standard'}
                              placeholder={'Enter Username'}
                              useFullWidth={true}
                              styleOverride={{}}
                              isError={isCreate && isNifcAlreadyUsed}
                              helperText={
                                  isCreate && isNifcAlreadyUsed
                                      ? 'Nifc Username is already in use'
                                      : ''
                              }
                          />
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>Is Admin</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <Select
                              key='isAdmin'
                              defaultValue=''
                              value={userIsAdmin}
                              onChange={(event) => {
                                  setUserIsAdmin(event.target.value);
                                  setIsUserDirty(true);
                              }}
                              fullWidth
                          >
                              <MenuItem value={FieldNames.yesNo.no} key='0'>
                                  {FieldNames.yesNo.no}
                              </MenuItem>
                              <MenuItem value={FieldNames.yesNo.yes} key='1'>
                                  {FieldNames.yesNo.yes}
                              </MenuItem>
                          </Select>
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>Is Active</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <Select
                              key='isActive'
                              defaultValue=''
                              value={userIsActive}
                              onChange={(event) => {
                                  setUserIsActive(event.target.value);
                                  setIsUserDirty(true);
                              }}
                              fullWidth
                          >
                              <MenuItem value={FieldNames.yesNo.no} key='0'>
                                  {FieldNames.yesNo.no}
                              </MenuItem>
                              <MenuItem value={FieldNames.yesNo.yes} key='1'>
                                  {FieldNames.yesNo.yes}
                              </MenuItem>
                          </Select>
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>Is Fuels</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <Select
                              key='isFuels'
                              defaultValue=''
                              value={userIsFuels}
                              fullWidth
                              onChange={(event) => {
                                  setUserIsFuels(event.target.value);
                                  setIsUserDirty(true);
                              }}
                          >
                              <MenuItem value={FieldNames.yesNo.no} key='0'>
                                  {FieldNames.yesNo.no}
                              </MenuItem>
                              <MenuItem value={FieldNames.yesNo.yes} key='1'>
                                  {FieldNames.yesNo.yes}
                              </MenuItem>
                          </Select>
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>Is Post Fire</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <Select
                              key='isPostFire'
                              defaultValue=''
                              value={userIsPostFire}
                              fullWidth
                              onChange={(event) => {
                                  setUserIsPostFire(event.target.value);
                                  setIsUserDirty(true);
                              }}
                          >
                              <MenuItem value={FieldNames.yesNo.no} key='0'>
                                  {FieldNames.yesNo.no}
                              </MenuItem>
                              <MenuItem value={FieldNames.yesNo.yes} key='1'>
                                  {FieldNames.yesNo.yes}
                              </MenuItem>
                          </Select>
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
          <FormControl variant='standard' className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                  <Grid
                      item
                      size={12}
                      container
                      direction='row'
                      className='grid-item'
                      style={{ alignItems: 'center', paddingRight: '5px' }}
                  >
                      <Grid item size={6}>
                          <span>
                              <label>Is Tribal</label>
                          </span>
                      </Grid>
                      <Grid item size={6}>
                          <Select
                              key='isTribal'
                              defaultValue=''
                              value={isTribalUser}
                              onChange={(event) => {
                                  if (event.target.value === FieldNames.yesNo.yes) {
                                      setRole({
                                          name: FieldNames.roles.local,
                                          code: FieldNames.roles.local,
                                      });
                                      setSelectedRole(FieldNames.roles.local);
                                      setAgencySelection([
                                          { Agency: FieldNames.agencies.uswfs },
                                          { Agency: FieldNames.agencies.bia },
                                      ]);
                                  }
                                  setIsTribalUser(event.target.value);
                                  setIsUserDirty(true);
                              }}
                              fullWidth
                          >
                              <MenuItem value={FieldNames.yesNo.no} key='0'>
                                  {FieldNames.yesNo.no}
                              </MenuItem>
                              <MenuItem value={FieldNames.yesNo.yes} key='1'>
                                  {FieldNames.yesNo.yes}
                              </MenuItem>
                          </Select>
                      </Grid>
                  </Grid>
              </ThemeProvider>
          </FormControl>
      </Fragment>
  );
}